const EXT_BY_CONTENT_TYPE: Record<string, string> = {
    'application/pdf': 'pdf',
    'text/csv': 'csv',
    'application/zip': 'zip',
};

function parseContentDispositionFilename(header?: string): string | null {
    if (!header) return null;
    const utf8 = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
    if (utf8?.[1]) return decodeURIComponent(utf8[1].trim().replace(/^"|"$/g, ''));
    const plain = header.match(/filename="?([^";]+)"?/i);
    return plain?.[1]?.trim() ?? null;
}

export function saveFileFromResponse(
    data: BlobPart,
    contentType?: string,
    contentDisposition?: string,
    fallbackName = 'Credit_Report',
) {
    const type = (contentType || '').split(';')[0].trim();
    const blob = new Blob([data], { type: type || 'application/octet-stream' });

    // Prefer the server-provided filename; otherwise derive one from the content type.
    const ext = EXT_BY_CONTENT_TYPE[type] || 'bin';
    const fileName =
        parseContentDispositionFilename(contentDisposition) || `${fallbackName}.${ext}`;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
